import { Spin } from "antd";
import "./index.less";

const Loading = () => {
	return <Spin size="large" className="request-loading" />;
};

export default Loading;
